import React from 'react';
import { gatewayApi, locationApi } from '../../../services/apis';
import {
  Dropdown,
  SearchableSelect,
  RadioButton,
  Button,
  MultiSelectDropDown,
} from '../../../component';
import { FormattedMessage } from 'react-intl';
import { PATH_CHOICES, WEEK_DAYS } from '../../../utils/consts/constance';
import { debouncing, generateFilterString } from '../../../utils/utility';

class AddGateWayForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airlinesList: [],
      gateWaysList: [],
      weekDaysValue: [{}],
      locationList: {
        origin: [],
        destination: [],
      },
      selectedLocation: {
        origin: '',
        destination: '',
      },
      locationPhrase: {
        origin: '',
        destination: '',
      },
      selectedGateWay: '',
      selectedAirplane: '',
      selectedPathChoice: '',
      weekDaysSelected: '',
      airlineStatus: 'known',
      airlineTypePhrase: '',
      gatewaySelectorePhrase: '',
      loading: false,
    };
  }

  componentDidMount = async () => {
    this.getAllGateways();
    this.getFlightLocation('origin');
    this.getFlightLocation('destination');
  };

  gatewayFilterElements = () => {
    const { gatewaySelectorePhrase } = this.state;
    return [{ key: 'phrase', value: gatewaySelectorePhrase }];
  };

  getAllGateways = async () => {
    try {
      const {
        status,
        payload: { data },
      } = await gatewayApi.getGateway({
        itemPerPage: 20,
        pageNumber: 0,
        data: {
          filter: generateFilterString(this.gatewayFilterElements()),
        },
      });
      if (status === 200) {
        this.setState({
          gateWaysList: data,
        });
      }
    } catch (error) {
      this.props.setToastData({
        alertMessage: 'error.receiveerror',
        toastState: 'danger',
      });
    }
  };

  getFlightLocation = async (locationType = 'origin') => {
    const { locationPhrase } = this.state;
    try {
      const {
        status,
        payload: { data },
      } = await locationApi.getAll({
        pageNumber: 1,
        itemPerPage: 25,
        data: {
          filter: {
            phrase: locationPhrase[locationType],
            countryCode: locationPhrase[locationType],
            type: locationPhrase[locationType],
          },
        },
      });
      if (status === 200) {
        this.setState((prevState) => ({
          locationList: {
            ...prevState.locationList,
            [locationType]: data,
          },
        }));
      }
    } catch (error) {
      this.props.setToastData({
        alertMessage: 'error.receiveerror',
        toastState: 'danger',
      });
    }
  };

  getAirlinesByGatewayCode = async () => {
    const { selectedGateWay } = this.state;
    try {
      const {
        status,
        payload: { data },
      } = await gatewayApi.getByGatewayCode({
        pageNumber: 1,
        itemPerPage: 25,
        data: {
          internalCode: selectedGateWay?.internalCode,
          phrase: '',
        },
      });
      if (status === 200)
        this.setState({
          airlinesList: data.result,
        });
    } catch (error) {
      this.props.setToastData({
        alertMessage: 'error.receiveerror',
        toastState: 'danger',
      });
    }
  };

  insertGatewayGDS = async () => {
    const {
      selectedPathChoice,
      weekDaysSelected,
      selectedAirplane,
      selectedLocation,
      selectedGateWay,
    } = this.state;
    try {
      const { status } = await gatewayApi.insert({
        data: {
          weekDays: weekDaysSelected,
          airlineCode: selectedAirplane?.code,
          internalCode: selectedGateWay?.internalCode,
          from:
            selectedPathChoice.id === 'ORIGIN-DES'
              ? selectedLocation?.origin?.code
              : selectedPathChoice.id,
          to:
            selectedPathChoice.id === 'ORIGIN-DES'
              ? selectedLocation?.destination?.code
              : selectedPathChoice.id,
        },
      });
      if (status === 200)
        this.props.setToastData({
          alertMessage: 'profile.addgatewaysuccessfully',
          toastState: 'success',
        });
    } catch (error) {
      this.props.setToastData({
        alertMessage: 'user.tryagain',
        toastState: 'danger',
      });
    } finally {
      this.setInitialValue();
    }
  };

  debouncingGetAllGateWay = debouncing(this.getAllGateways, 700);
  debouncingGetLocation = debouncing(this.getFlightLocation, 700);

  handleSelectWeekDays = (e) => {
    let result = [];
    e?.value?.map((item) => result.push(item.id));
    this.setState({
      weekDaysValue: e?.value,
      weekDaysSelected: result.join(','),
    });
  };

  setInitialValue = () => {
    this.setState({
      weekDaysValue: [{}],
      selectedAirplane: {},
      selectedPathChoice: {},
      selectedLocation: {
        origin: '',
        destination: '',
      },
      selectedArrivalLocation: {},
      weekDaysSelected: '',
      selectedGateWay: '',
      airlineStatus: 'known',
    });
  };

  handleDisableSubmit = () => {
    const {
      selectedPathChoice,
      selectedLocation,
      selectedAirplane,
      airlineStatus,
      weekDaysSelected,
    } = this.state;
    if (airlineStatus === 'known') {
      if (selectedPathChoice?.id === 'ORIGIN-DES') {
        return (
          selectedLocation.origin &&
          selectedAirplane &&
          selectedLocation.destination &&
          weekDaysSelected
        );
      } else {
        return selectedAirplane && weekDaysSelected;
      }
    }
    if (airlineStatus === 'unknown') {
      if (selectedPathChoice?.id === 'ORIGIN-DES') {
        return (
          selectedLocation.origin &&
          selectedLocation.destination &&
          weekDaysSelected
        );
      } else {
        return selectedAirplane && weekDaysSelected;
      }
    }
  };

  render() {
    const {
        airlineStatus,
        airlinesList,
        weekDaysValue,
        selectedAirplane,
        selectedPathChoice,
        locationList,
        selectedLocation,
        loading,
        gateWaysList,
        selectedGateWay,
      } = this.state,
      {
        intl,
        language,
        language: { name },
      } = this.props;
    return (
      <>
        <div className={`w-100 px-3`}>
          <div
            id="addGatewayGDS-form"
            name="addGatewayGDS-form"
            className="d-flex flex-column justify-content-center align-items-center w-100 px-0 bg-white  default-border-radius-small"
          >
            <div className="col-12 px-0 py-3 d-flex flex-xs-row flex-column">
              <div className="flex-grow-1 invite-form-container col-6 px-sm-3 px-0 ">
                <div className="w-100 d-flex flex-row justify-content-start ">
                  <img
                    className="img-fluid default-border-radius-small w-100 img-setup"
                    alt=""
                    src={require('../../../content/images/elements/gateway.png')}
                  />
                </div>
              </div>
              <div className="col-6 px-md-3 px-xs-1 px-3 py-xs-0 py-3 d-flex flex-column justify-content-start align-items-start">
                <div className="w-100 d-flex flex-column justify-content-start align-items-start">
                  <span className="text-primary pt-sm-5 pt-3 font-sm-xxlarge font-normal text-nowrap">
                    <FormattedMessage id={`profile.addgateway`} />
                  </span>
                  <div
                    className={`col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0 ${
                      language?.direction === 'rtl' ? 'pl-2' : 'pr-2'
                    }`}
                  >
                    <p className="font-xl-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                      <FormattedMessage id={`profile.addgatewaydescription`} />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-column pb-5 pt-2">
              <div className="d-flex flex-sm-row flex-column pb-4 m-0 col-sm-6 col-12 px-3 pt-sm-0 pt-3">
                <label className="px-2 text-start text-nowrap">
                  <FormattedMessage id="profile.airlinestatus" />
                  <span className="px-2">:</span>
                </label>
                <fieldset className="d-flex justify-content-start flex-fill px-sm-0 px-3 pb-sm-0 pb-2 text-nowrap">
                  <RadioButton
                    name="airlineStatus"
                    label="profile.known"
                    inputClassName="font-weight-bold m-0 font-msmall"
                    checked={airlineStatus === 'known'}
                    onChange={(event) =>
                      this.setState({
                        airlineStatus: event.target.value,
                      })
                    }
                    value={'known'}
                  />
                  <RadioButton
                    name="airlineStatus"
                    label="profile.unknown"
                    inputClassName="font-weight-bold m-0 px-2 font-msmall"
                    checked={airlineStatus === 'unknown'}
                    onChange={(event) =>
                      this.setState({
                        airlineStatus: event.target.value,
                      })
                    }
                    value={'unknown'}
                  />
                </fieldset>
              </div>
              <div className="col-12 d-flex flex-wrap flex-sm-row flex-column">
                {airlineStatus === 'known' && (
                  <>
                    <fieldset className="col-sm-6 col-12 d-flex justify-content-center pb-4 mb-4">
                      <SearchableSelect
                        themeMode="light"
                        name="airlineType"
                        placeholder={intl.formatMessage({
                          id: 'profile.choosegateway',
                        })}
                        list={gateWaysList}
                        display={`name`}
                        type="city"
                        isLocalization={true}
                        search={(event) =>
                          this.setState(
                            {
                              gatewaySelectorePhrase: event.target.value,
                            },
                            () => this.debouncingGetAllGateWay(),
                          )
                        }
                        select={(item) =>
                          this.setState(
                            {
                              selectedGateWay: item,
                            },
                            () => this.getAirlinesByGatewayCode(),
                          )
                        }
                        defaultValue={selectedGateWay?.name}
                        shouldBeFilled={true}
                        containerClass="w-100"
                        labelColor="text-dark font-msmall"
                        inputClassname="py-1 font-msmall"
                        heightSize={'height-55px px-lg-0 px-3'}
                        listClass="default-border-bottom-radius-small bg-third-light border-color-light-primary"
                      />
                    </fieldset>
                    <fieldset className="col-sm-6 col-12 d-flex justify-content-center pb-4 mb-4">
                      <SearchableSelect
                        themeMode="light"
                        name="airlineType"
                        placeholder={intl.formatMessage({
                          id: 'profile.airlinetype',
                        })}
                        list={airlinesList}
                        display={`name.${name}`}
                        type="city"
                        isLocalization={true}
                        search={(event) =>
                          this.setState({
                            airlineTypePhrase: event.target.value,
                          })
                        }
                        select={(item) =>
                          this.setState({
                            selectedAirplane: item,
                          })
                        }
                        defaultValue={selectedAirplane?.name?.[name]}
                        shouldBeFilled={true}
                        containerClass="w-100"
                        labelColor="text-dark font-msmall"
                        inputClassname="py-1 font-msmall"
                        heightSize={'height-55px px-lg-0 px-3'}
                        listClass="default-border-bottom-radius-small bg-third-light border-color-light-primary"
                      />
                    </fieldset>
                  </>
                )}
                <fieldset className="col-sm-6 col-12 d-flex justify-content-center align-items-end pb-4 mb-4">
                  <Dropdown
                    classNames="w-100 bg-third-light border-color-light-primary height-55px"
                    name={`pathChoice`}
                    id={`pathChoice`}
                    label="profile.pathchoice"
                    value={selectedPathChoice?.name?.[name]}
                    options={{
                      data: PATH_CHOICES,
                      label: `name.${name}`,
                      value: 'id',
                    }}
                    onChange={(event) =>
                      this.setState({
                        selectedPathChoice: event.currentTarget.valueObject,
                      })
                    }
                    theme="dark"
                    outSideLabel={true}
                    labelPosition="top"
                    withoutShadow={true}
                    maxHeight="55px"
                    iconNameDrp={null}
                  />
                </fieldset>
                {selectedPathChoice?.id === 'ORIGIN-DES' && (
                  <>
                    <fieldset className="col-sm-6 col-12 d-flex justify-content-center align-items-end mb-4 pb-4">
                      <SearchableSelect
                        themeMode="light"
                        name="departureflightcity'"
                        placeholder={intl.formatMessage({
                          id: 'profile.departureflightcity',
                        })}
                        list={locationList.origin}
                        display={`name.${name}`}
                        type="city"
                        isLocalization={true}
                        search={(event) =>
                          this.setState(
                            (prevState) => ({
                              locationPhrase: {
                                ...prevState.locationPhrase,
                                origin: event.target.value,
                              },
                            }),
                            () => this.debouncingGetLocation('origin'),
                          )
                        }
                        select={(item) =>
                          this.setState((prevState) => ({
                            selectedLocation: {
                              ...prevState.selectedLocation,
                              origin: item,
                            },
                          }))
                        }
                        defaultValue={selectedLocation.origin?.name?.[name]}
                        shouldBeFilled={true}
                        containerClass="w-100"
                        labelColor="text-dark font-msmall"
                        inputClassname="py-1 font-msmall"
                        heightSize={'height-55px px-lg-0 px-3'}
                        listClass="default-border-bottom-radius-small bg-third-light border-color-light-primary"
                      />
                    </fieldset>
                    <fieldset className="col-sm-6 col-12 d-flex justify-content-center align-items-end mb-4 pb-4">
                      <SearchableSelect
                        themeMode="light"
                        name="airlineType"
                        placeholder={intl.formatMessage({
                          id: 'profile.arrivalflightcity',
                        })}
                        list={locationList.destination}
                        display={`name.${name}`}
                        type="city"
                        isLocalization={true}
                        search={(event) =>
                          this.setState(
                            (prevState) => ({
                              locationPhraes: {
                                ...prevState.locationPhraes,
                                destination: event.target.value,
                              },
                            }),
                            () => this.debouncingGetLocation('destination'),
                          )
                        }
                        select={(item) =>
                          this.setState((prevState) => ({
                            selectedLocation: {
                              ...prevState.selectedLocation,
                              destination: item,
                            },
                          }))
                        }
                        defaultValue={
                          selectedLocation.destination?.name?.[name]
                        }
                        shouldBeFilled={true}
                        containerClass="w-100"
                        labelColor="text-dark font-msmall"
                        inputClassname="py-1 font-msmall"
                        heightSize={'height-55px px-lg-0 px-3'}
                        listClass="default-border-bottom-radius-small bg-third-light border-color-light-primary"
                      />
                    </fieldset>
                  </>
                )}
                <fieldset className="col-sm-6 col-12 d-flex flex-column justify-content-center align-items-end mb-4 pb-4">
                  <label className="text-dark px-3 pb-2 text-start w-100 m-0 font-msmall">
                    <FormattedMessage id="profile.selectflightsdays" />
                  </label>
                  <MultiSelectDropDown
                    name="weekDays"
                    label={''}
                    id="weekDays"
                    data={WEEK_DAYS}
                    value={weekDaysValue}
                    topPosition="top"
                    show="name"
                    send="id"
                    onClick={this.handleSelectWeekDays}
                    theme="light"
                    tabIndex={'3'}
                    classNameInput="height-input-profile"
                  />
                </fieldset>
                <div className="w-100 d-flex flex-sm-row flex-column-reverse">
                  <fieldset className="d-flex flex-row justify-content-end align-items-center px-3 pb-0 label-small col-12 col-sm-6 mt-sm-3 mt-5">
                    <Button
                      id="friend-form-submit"
                      name="friend-form-submit"
                      label={intl.formatMessage({
                        id: `profile.reload`,
                      })}
                      className="btn-third"
                      tabIndex="7"
                      onClick={() => this.setInitialValue()}
                    />
                  </fieldset>
                  <fieldset className="d-flex flex-row justify-content-end align-items-center px-3 pb-0 label-small col-12 col-sm-6 mt-3">
                    <Button
                      id="friend-form-submit"
                      name="friend-form-submit"
                      label={intl.formatMessage({
                        id: `profile.submitaddgateway`,
                      })}
                      onClick={() => {
                        this.insertGatewayGDS();
                      }}
                      loading={loading}
                      disabled={!this.handleDisableSubmit()}
                      className="btn-secondary"
                      tabIndex="7"
                    />
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AddGateWayForm;
